import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Anna K.',
  city: 'München'
}, {
  name: 'Lena S.',
  city: 'Hamburg'
}, {
  name: 'Markus W.',
  city: 'Köln'
}, {
  name: 'Sophie B.',
  city: 'Berlin'
}, {
  name: 'Julia M.',
  city: 'Stuttgart'
}, {
  name: 'Thomas R.',
  city: 'Dresden'
}, {
  name: 'Katharina F.',
  city: 'Leipzig'
}, {
  name: 'Nina H.',
  city: 'Frankfurt'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6000);
    };
    const initial = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center sm:left-auto sm:right-4 sm:max-w-[285px]" data-id="element-163">
      <div className="pointer-events-auto relative w-full animate-slide-in rounded-lg border-2 border-brand-gold bg-brand-burgundy p-2.5 pr-8 text-white shadow-[0_6px_22px_rgba(80,30,40,.4)]" data-id="element-164">
        <button onClick={() => setVisible(false)} aria-label="Popup schließen" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/70 hover:text-white focus-visible:outline focus-visible:outline-2" data-id="element-165">
          <XIcon className="h-4 w-4" data-id="element-166" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-167">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-gold bg-brand-goldLight text-brand-burgundy" data-id="element-168">
            <ShoppingBagIcon className="h-4 w-4" data-id="element-169" />
          </span>
          <div className="leading-tight" data-id="element-170">
            <p className="text-xs font-bold" data-id="element-171">
              {purchase.name} aus {purchase.city}, Deutschland
            </p>
            <p className="mt-0.5 text-[11px] font-semibold text-brand-cream" data-id="element-172">
              hat gerade DANCE PRO™ gekauft
            </p>
          </div>
        </div>
      </div>
    </aside>;
}